import React, { ReactNode } from "react";
import styled from "styled-components";
import { colors } from "../../theme/color";
import fonts from "../../theme/fonts";

interface HeaderTextProps {
  children: ReactNode;
}

const StyledHeaderText = styled.h1`
  text-align: left;
  color: ${colors.PURPLE};
  margin: 20px 0px;
  padding-top: 70px;
  font-weight: ${fonts.fontWeight.bold};
`;

export const HeaderText: React.FC<HeaderTextProps> = ({ children }) => {
  return <StyledHeaderText>{children}</StyledHeaderText>;
};
